module.exports = __webpack_public_path__ + "img/9788982739040.be12b477.jpg";